<template>
  <div>
    <breadcrumb v-bind:path2="path2"></breadcrumb>
    <div class="qrCode">
      <!-- title and content -->
      <div class="page-width pre-formatted padding">
        <h2>Download the Asian Food Grocer App!</h2>
        <p>Take your shopping to-go with the Asian Food Grocer app on iOS and Android.</p>
        <div class="image-holder">
          <img src="../../assets/img/app_ios.png"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';

export default {
  name: "qrCode",
  components: {
    breadcrumb,
  },
  data() {
    return {
      path2: 'QR Code',
    }
  }
}
</script>

<style scoped lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/about.less";
</style>



// WEBPACK FOOTER //
// src/view/Footer/qrCode.vue